module.exports = __webpack_public_path__ + "img/var_01_mobile.b4138723.png";